var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundImprimir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 595,
    height: 587,
    viewBox: "0 0 595 587",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.5 149C327.5 231.29 66.0371 298 -21.5 298C-109.037 298 -180 231.29 -180 149C-180 66.7096 -109.037 0 -21.5 0C112.5 33.5 327.5 66.7096 327.5 149Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595 103.025L542.311 87.502C490.676 71.9786 341.378 72.6915 236 111.5C131.676 150.309 72.3244 174.395 20.6891 226.139L-32 280.471V473H20.6891C72.3244 473 176.649 473 280.973 473C386.351 473 490.676 473 542.311 473H595V103.025Z",
    fill: "#262A32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 304.131L50 292.262C99 280.394 198 256.657 298 286.328C397 316 496 358.697 545 398.26L595 439.8V587H545C496 587 397 587 298 587C198 587 99 587 50 587H0V304.131Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundImprimir);
export default __webpack_public_path__ + "static/media/backgroundImprimir.c127c01284376c2bc339b59f154d6144.svg";
export { ForwardRef as ReactComponent };